module.exports = __webpack_public_path__ + "media/exchange.5ef24fc4.mp3";